const renderBody = (body) =>
  body.split(/\n\n+/).map((para, i) => {
    const lines = para.split("\n").filter((l) => l.trim());
    const isList = lines.length > 0 && lines.every((l) => l.trim().startsWith("- "));
    if (isList) {
      return (
        <ul key={i} className="space-y-2 my-2">
          {lines.map((l, j) => (
            <li key={j} className="flex gap-2 items-start text-slate-700 leading-relaxed">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-600 mt-2 shrink-0" />
              <span>{l.trim().slice(2)}</span>
            </li>
          ))}
        </ul>
      );
    }
    return (
      <p key={i} className="text-slate-700 leading-relaxed mb-3">
        {para}
      </p>
    );
  });

export default function PageSections({ blocks, testPrefix = "page" }) {
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 py-14 space-y-6" data-testid={`${testPrefix}-sections`}>
      {blocks.map((b, i) => (
        <div key={i} className="bg-white rounded-2xl border border-emerald-100 shadow-sm p-6 sm:p-8" data-testid={`${testPrefix}-section-${i}`}>
          {b.title && (
            <h2 className="font-heading text-lg sm:text-xl font-bold text-emerald-900 mb-3 flex items-center gap-3">
              <span className="w-2 h-8 bg-amber-600 rounded-full shrink-0" />
              {b.title}
            </h2>
          )}
          <div className={b.title ? "pl-5" : ""}>{renderBody(b.body || "")}</div>
        </div>
      ))}
    </section>
  );
}
